/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import React from "react";
import { CmpButtonTalkTo } from "../CmpButtonTalkTo";
import "./style.css";

export const CmpAskcoachfab = ({ className }) => {
  return (
    <div className={`cmp-askcoachfab ${className}`}>
      <CmpButtonTalkTo property1="default" text="Chat with Cedar about this" />
    </div>
  );
};
